import { z } from 'zod'
import { oc } from '@orpc/contract'
import { cellRefSchema } from './boards-shared.contract'

export const boardAssignees = oc
  .route({ method: 'GET', path: '/v2/boards-directory/assignees' })
  .input(z.object({}).optional())
  .output(z.object({ assignees: z.array(cellRefSchema) }))

export const boardPatientSearch = oc
  .route({ method: 'GET', path: '/v2/boards-directory/patients' })
  .input(z.object({ query: z.string().trim().min(1).max(100) }))
  .output(z.object({ patients: z.array(cellRefSchema) }))
